<template>
<section :class="classes">
	<Heading :level="1" text="Declarations" />
	<form @submit.prevent="saveAndSubmit" novalidate ref="form" class="view-wrap three-quarters m-b-2">
		<HelpText classes="m-b-2">
			<template #text>
				<p>Please note, the following declaration is mandatory.</p>
			</template>
		</HelpText>

		<CheckboxField
			ref="ua_agreetodataprotection"
			name="ua_agreetodataprotection"
			:label-text="labels.ua_agreetodataprotection"
			:value="formData.ua_agreetodataprotection"
			@emitFieldData="(val) => formData.ua_agreetodataprotection = val"
			required-error="You must agree to this declaration to proceed" />

		<SelectField
			name="ua_wheredidyouhearaboutus"
			ref="ua_wheredidyouhearaboutus"
			label-text="Where did you hear about us?"
			:value="formData.ua_wheredidyouhearaboutus"
			@emitFieldData="(val) => formData.ua_wheredidyouhearaboutus = val"
			required-error="Please select an option"
			:options-loading="false"
			:options="whereDidYouHearOpts" />

		<template v-if="isOther">
			<InputField
				name="ua_wheredidyouhearaboutusother"
				ref="ua_wheredidyouhearaboutusother"
				label-text="If Other, please tell us where you heard about us."
				:value="formData.ua_wheredidyouhearaboutusother"
				@emitFieldData="(val) => formData.ua_wheredidyouhearaboutusother = val"
				:validation-rules="[(v) => rules.containsLength(v, 4, null)]" />
		</template>
	</form>
</section>
</template>

<script>

import { formSteps } from '@/mixins/eoiFormSteps';
import { formValidator } from '@/mixins/formValidator';
import { validationRules } from '@/utilities/validationRules';

export default {
	name: 'DeclarationList',
	mixins: [formValidator, formSteps],
	props: {
		classes: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			rules: validationRules,
			formData: {
				ua_agreetodataprotection: false,
				ua_wheredidyouhearaboutus: '',
				ua_wheredidyouhearaboutusother: '',
				ua_pleasedescribeproject: ''
			},
			labels: {
				ua_agreetodataprotection: `<h4>Use of information</h4>
																	<p>The information provided in this registration form will be used by UMi (the delivery partner for the Durham Business Growth Programme), and/or RTC and Business Durham for administering your request for registration and to contact you regarding your application for business support.</p>
																	<p>As part of your involvement in the programme, we will send you relevant information and documents by email, post or phone. You can change your mind at any time.</p>
																	<p>Please view the full privacy notice on data collection for this project at <a href="https://www.durhambusinessgrowth.co.uk/privacy-policy" target="_blank" rel="noopener nofollow">https://www.durhambusinessgrowth.co.uk/privacy-policy</a></p>`
			},
			whereDidYouHearOpts: [
				{ label: 'Email', value: 1 },
				{ label: 'Event', value: 2 },
				{ label: 'IFlyer', value: 3 },
				{ label: 'News / Media', value: 4 },
				{ label: 'Other (please specify)', value: 5 },
				{ label: 'Supplier / Provider', value: 6 },
				{ label: 'Website', value: 7 },
				{ label: 'Word of Mouth', value: 8 }

			]

		};
	},
	computed: {
		isOther () {
			return this.formData.ua_wheredidyouhearaboutus === '5';
		}
	}

};
</script>

<style scoped lang="scss">
label h4 {
	margin-block-start: 0;
}

label p + h4 {
	margin-block-end: .5rem;
}
</style>
